export default "__VITE_ASSET__d9b8ebb5__"